import { UserConfiguration } from "@app/core/user/domain/user-configuration";
import { Language } from "@app/core/user/domain/language";

export class UserConfigurationMapper {
  private static readonly KEY_CATALAN = "ca";
  private static readonly KEY_SPANISH = "es";
  private static readonly KEY_ENGLISH = "en";
  private static readonly KEY_FRENCH = "fr";
  private static readonly KEY_GERMAN = "de";
  private static readonly KEY_ITALIAN = "it";
  private static readonly KEY_NETHERLANDS = "nl";
  private static readonly KEY_PORTUGUESE = "pt";
  private static readonly KEY_RUSSIAN = "ru";

  static deserialize(data: any): UserConfiguration {
    const language = this.languageDeserialize(data.language);
    const unit = data.units;
    const availableLanguages = this.availableLanguagesDeserialize(
      data.available_languages
    );
    return new UserConfiguration({
      language: language,
      availableLanguages: availableLanguages,
      units: unit,
      hasChat: data.has_chat ?? false,
    });
  }

  static serialize(configuration: UserConfiguration): any {
    const language =
      configuration.language != null
        ? this.languageSerialize(configuration.language)
        : null;
    return {
      language: language,
      units: configuration.units,
    };
  }

  static languageDeserialize(language: string): Language | null {
    switch (language) {
      case this.KEY_CATALAN:
        return Language.CATALAN;
      case this.KEY_SPANISH:
        return Language.SPANISH;
      case this.KEY_ENGLISH:
        return Language.ENGLISH;
      case this.KEY_FRENCH:
        return Language.FRENCH;
      case this.KEY_GERMAN:
        return Language.GERMAN;
      case this.KEY_ITALIAN:
        return Language.ITALIAN;
      case this.KEY_NETHERLANDS:
        return Language.NETHERLANDS;
      case this.KEY_PORTUGUESE:
        return Language.PORTUGUESE;
      case this.KEY_RUSSIAN:
        return Language.RUSSIAN;
      default:
        return null;
    }
  }

  static languageSerialize(language: Language): string {
    switch (language) {
      case Language.CATALAN:
        return this.KEY_CATALAN;
      case Language.SPANISH:
        return this.KEY_SPANISH;
      case Language.ENGLISH:
        return this.KEY_ENGLISH;
      case Language.FRENCH:
        return this.KEY_FRENCH;
      case Language.GERMAN:
        return this.KEY_GERMAN;
      case Language.ITALIAN:
        return this.KEY_ITALIAN;
      case Language.NETHERLANDS:
        return this.KEY_NETHERLANDS;
      case Language.PORTUGUESE:
        return this.KEY_PORTUGUESE;
      case Language.RUSSIAN:
        return this.KEY_RUSSIAN;
      default:
        throw new Error("Language not found");
    }
  }

  static availableLanguagesDeserialize(languages: string[]): Language[] {
    return languages
      .map((language) => this.languageDeserialize(language))
      .filter((language) => language != null) as Language[];
  }
}
